import getIsServiceCreated from "./getIsServiceCreated";
/**
 * Determine if News is ready to be updated based on the input properties
 * of various reviews and an ID.
 *
 * @function getIsNewsReadyToBeUpdated
 * @param {NewsUpdatedProps} props - An object containing review properties
 * and News ID.
 * @returns {boolean} - If true, News is considered ready to be updated; otherwise, false.
 *
 */
const getIsNewsReadyToBeUpdated = ({ avNirvana, bluRay, hidefDigest, id, news, whySoBlu }) => 
// Check if id exists, and if each review service is valid
// by calling getIsServiceCreated with the respective review's url and ID
Boolean(id) &&
    getIsServiceCreated(avNirvana, news.sourcesIds) &&
    getIsServiceCreated(bluRay, news.sourcesIds) &&
    getIsServiceCreated(hidefDigest, news.sourcesIds) &&
    getIsServiceCreated(whySoBlu, news.sourcesIds);
export default getIsNewsReadyToBeUpdated;
